import formatData from "./formatData";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
const formatProgrameOnsiteData = async function(item) {

  const data = item;
  data.dateText = item.date.toDate();
  data.dateDatepicker = formatData("datepicker", item.date.toDate());
  data.coachInfo = await getUserInfoByUserId(item.updatedBy);

  return data;
};
export default formatProgrameOnsiteData;
